module.exports = __webpack_public_path__ + "static/media/dBrat.795025a6.jpeg";